import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        title:
            'mb-2 bg-clip-text font-(family-name:--primary-font) text-[1.3rem] tracking-[-0.01em] ' +
            '[-webkit-text-fill-color:transparent]',
        description:
            'mb-6 max-w-88 font-(family-name:--secondary-font) text-[0.92rem] leading-[1.7] ' +
            'text-(--text-light,var(--color-slate-grey-500))'
    },
    variants: {
        error: {
            true: {
                title: 'bg-[linear-gradient(135deg,var(--color-strawberry-red-400),var(--color-primary-scarlet-500))]'
            },
            false: {
                title: 'bg-(image:--accent-gradient,linear-gradient(135deg,var(--color-blue-violet-400),var(--color-electric-indigo-500)))'
            }
        }
    }
} satisfies ComponentTheme;
